export const serviceList = [
  'Groß- und Einzelhandel allgemein',
  'Campingplätze',
  'Caterer und Erbringung sonstiger Verpflegungsdienstleistungen',
  'Verwaltung, Beratung',
  'Kindergärten, Schulen',
  'Arzt- und Zahnarztpraxen',
  'Pflegeheime und andere Betreuungseinrichtungen',
  'Frisör- und Kosmetiksalons',
  'Saunas, Solarien, Bäder u. Ä.',
  'Landwirtschaft',
  'Herstellung von Nahrungs-und genussmitteln',
  'Elektrizitätsversorgung',
  'Wasserver- und Entsorgung',
  'Elektro-, Gas-, Wasser-, Heizungs- sowie Lüftungs- und Klimainstallation',
  'Instandhaltung und Reparatur von Kraftwagen und –rädern.',
  'Restaurants',
  'Hotel',
  'Vermittlung von Arbeitskräften',
  'Krankenhäuser',
  'Forstwirtschaft',
]

// 9 elements 0.5
//10 elements 1.5
//1 2.5
